module.exports = __webpack_public_path__ + "img/excel.d0b86f5e.png";